import PropTypes from 'prop-types';

import { useAppDispatch, useAppSelector } from 'dux/app/hooks';

import { styled } from '@prose-ui/legacy';

import { Button } from 'Components/LegacyButton';
import { Typography } from 'Components/Typography';

import { getCartV2UpdatingStatus } from 'dux/cartV2/selectors';
import { useTrackCartV2OnAddFromPageProduct } from 'dux/cartV2/hooks';
import { updateCartV2ItemsQuantity } from 'dux/cartV2/thunks';

const StyledTypography = styled(Typography)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin-top: 1px;

  font-weight: bold;
`;

const CartV2ProductCTA = ({ item, className, fixed }) => {
  const dispatch = useAppDispatch();
  const isUpdating = useAppSelector(getCartV2UpdatingStatus);

  const { onAdd } = useTrackCartV2OnAddFromPageProduct();

  const onClick = async () => {
    onAdd(item.variant_slug || item.product_type);
    await dispatch(
      updateCartV2ItemsQuantity({
        quantity: 1,
        variant_slug: item.variant_slug || item.product_type,
      })
    );
  };

  return (
    <Button
      className={className}
      data-click="add-to-cart"
      data-from="pdp-hero"
      data-testid="add-to-cart"
      disabled={isUpdating}
      fixed={fixed}
      isLoading={isUpdating}
      onClick={onClick}
      variant="vert"
    >
      <StyledTypography markupName="h2" variant="mono2">
        Add to cart
      </StyledTypography>
    </Button>
  );
};

CartV2ProductCTA.propTypes = {
  className: PropTypes.string,
  fixed: PropTypes.bool,
  item: PropTypes.shape({
    variant_slug: PropTypes.string,
    product_type: PropTypes.string,
  }).isRequired,
};

CartV2ProductCTA.defaultProps = {
  className: null,
  fixed: false,
};

export default CartV2ProductCTA;
